import axios from "axios";
import React, {Component} from "react";
import FeatherIcon from 'feather-icons-react';
import Listprint from "../../Listprint";
import BookForm from "./BookForm";

class   Book extends Component{

    state = {
        isModal : false,
        formData : null,
        time_end : null,
        books : [],
    }

    componentDidMount(){
        this.getBooks();
    }

    handleInputM = (e) => {
        this.getBooks();
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    async getBooks(){
        this.setState({ books : [] })
        var books = await axios.get('books');
        if(books.status === 200)
        {
            this.setState({books : books.data}) 
        }
    }

    showModal = (book = null) => {
        this.setState({
            isModal : !this.state.isModal,
            formData : book,
        })
        this.getBooks();
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    delete = (book) =>{
        axios.delete("books/" + book).then((response) => {
            this.getBooks()
        }).catch((error)=>{})
    }

  handleCheck(val) {
    var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
     return  permissions.some(item => val === item.permission);
 }

    render(){
        var rows = [], columns = [
            {
                label: 'Livre',
                field: 'book',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Edition',
                field: 'edition',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Référence',
                field: 'reference',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Emplacement',
                field: 'spot',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Auteur',
                field: 'author',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Nationalité',
                field: 'nationality',
                sort: 'asc',
                width: 50
            },
            {
                label: '#',
                field: 'action',
                sort: 'asc',
                width: 50,
                class: 'table_action'
            },
        ];
        this.state.books.map((book) => {
            var author = "", nationality = "";
            book.authorbooks.map(authorbook => {
                author += authorbook.author.last_name + " " + authorbook.author.first_name + " , ";
                nationality += authorbook.author.nationality + " , ";
            })
            rows.push({
                book : book.title,
                edition : book.edition,
                reference : book.spot.reference,
                spot : book.spot.spot,
                author : author,
                nationality : nationality,
                action : <span className="table_action">
                        {
                            this.handleCheck("Modifier livre") == true && (
                                <div className="widget-todo-item-action d-flex align-items-center">
                                    <FeatherIcon icon="edit-2" size="16" className='cursor-move text-primary' type="button" onClick={() => this.showModal(book)}></FeatherIcon>
                                </div>
                            )
                        }
                </span>
            })
        })
        return(
            <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h5 className="h5 font-monospace">Livres</h5>
                {
                    this.handleCheck("Ajouter livre") == true && (
                        <div className="btn-toolbar mb-2 mb-md-0">
                            <div className="btn-group me-2">
                                <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.showModal(null)}><FeatherIcon icon="plus-circle" ></FeatherIcon></button>
                            </div>
                        </div>
                    )
                }
            </div>
            

            <div className="card shadow mb-2">
                <div className="card-body">
                    <div className="row overflow-auto mt-2">
                        {
                            rows.length > 0 && (
                                <Listprint columns={columns} rows={rows} title={"Les differents auteurs"}/>
                            )
                        }
                    </div>
                </div>
            </div>

            <BookForm
                isModal={this.state.isModal} 
                formData={this.state.formData} 
                showModal={this.showModal}
            />

        </div>
        )
    }
}
export default Book;
